<template>
  <div class="teaching-evaluate-apply-common-quota-update">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDialog :visible.sync="visible"
                    width="420px"
                    title="修改评教指标"
                    custom-class="teaching-evaluate-apply-common-quota-update-dialog"
                    @open="handleReset">
      <div class="quota-update-main">
        <div class="main-cont"
             v-loading="committing"
             element-loading-text="数据提交中，请稍等...">
          <el-form size="mini"
                   label-position="top"
                   label-suffix="：">
            <el-form-item label="评教指标名称">
              <el-input v-model="form.label"
                        type="text"
                        maxlength="50"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="footer">
          <el-button size="mini"
                     type="primary"
                     :disabled="committing"
                     @click="handleApply">提交保存</el-button>
          <el-button size="mini"
                     type="default"
                     @click="handleClose">取消操作</el-button>
        </div>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../../../../../../elements/grid/DataGridDialog'
export default {
  name: 'TeachingEvaluateApplyCommonQuotaUpdate',
  components: {
    DataGridDialog
  },
  props: {
    evaluation: {
      type: Object,
      required: true
    },
    commonQuota: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      form: {
        label: ''
      },
      committing: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    handleApply () {
      if (!this.form.label) {
        this.$message.warning('方案名称不能为空')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/teaching/evaluate/apply/common/updateQuota',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          id: this.evaluation.id,
          quotaId: this.commonQuota.id
        }, this.form))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.handleClose()
              this.$nextTick(() => {
                Object.keys(this.form).forEach(key => {
                  this.$set(this.commonQuota, key, this.form[key])
                })
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.visible = false
    },
    handleReset () {
      Object.keys(this.form).forEach(key => {
        this.form[key] = this.commonQuota[key] || ''
      })
    }
  }
}
</script>

<style lang="scss">
  .teaching-evaluate-apply-common-quota-update {
    display: inline-block;
  }
  .teaching-evaluate-apply-common-quota-update-dialog {
    .quota-update-main {
      & > .main-cont {
        padding: 15px 20px;
        .el-form {
          .el-form-item {
            margin-bottom: 10px;
            .el-form-item__label {
              font-size: 12px;
              padding-bottom: 4px;
            }
          }
        }
      }
      & > .footer {
        height: 52px;
        background-color: #fff;
        border-top: 1px solid rgba(0,0,0,.05);
        text-align: center;
        line-height: 50px;
      }
    }
  }
</style>
